/**
 * 文の台帳（shelf）。まとめは ../ui-texts.ts。
 * 管理UIへ写すので、../ui-texts.ts の型の他は何も import しない
 */
import type { UiTextDef } from "../ui-texts";

export const SHELF_TEXTS = {
  // 書庫の上の帯
  "shelf.heading": { text: "私の書庫", label: "書庫の見出し", note: "画面には出ない（読み上げだけ）" },
  "shelf.count.total": { text: "{冊数}冊の蔵書", label: "上の帯の蔵書の冊数", vars: "{冊数}" },
  "shelf.dailyButton": { text: "今日の読み方", label: "上の帯の右の、今日の読み方の画面へのしおり", note: "選んだ読み方の色になる。読み上げは「今日の読み方：〇〇」（nav.dailyRibbon の文）" },
  "shelf.dailyPanel.aria": { text: "今日の読み方", label: "書庫から見る今日の読み方の栞の読み上げの名前", note: "画面には出ない" },
  "shelf.dailyPanel.eyebrow": { text: "今日の読み方", label: "書庫から見る今日の読み方の栞の、名前の上の小さな字" },
  "shelf.dailyPanel.progress": { text: "{進み}/{目標}", label: "書庫から見る栞のミッションの進み", vars: "{進み}・{目標}" },
  "shelf.dailyPanel.delivered": { text: "報酬はプレゼントボックスに届きました", label: "書庫から見る栞のミッションの下の行（達成したとき）" },
  "shelf.dailyPanel.open": { text: "今日の読み方の画面へ", label: "書庫から見る栞の下のボタン（今日の読み方の画面へ）" },
  "shelf.dailyPanel.close": { text: "閉じる", label: "書庫から見る栞の下のボタン（閉じる）" },
  "shelf.count.unread": { text: "未読 {冊数}冊", label: "上の帯の未読の冊数", note: "蔵書の冊数の後ろ（間に · が入る）", vars: "{冊数}" },

  // 書庫のタブ
  "shelf.tabs.aria": { text: "書庫の表示切り替え", label: "タブの並びの読み上げの名前", note: "画面には出ない" },
  "shelf.tabs.list": { text: "書物一覧", label: "タブ（書物一覧）" },
  "shelf.tabs.shelf": { text: "本棚", label: "タブ（本棚）" },
  "shelf.tabs.vocab": { text: "単語帳", label: "タブ（単語帳）" },

  // 書物一覧の検索と並び順
  "shelf.search.aria": { text: "作品名で検索", label: "書物一覧の検索欄の読み上げの名前", note: "画面には出ない" },
  "shelf.search.placeholder": { text: "書庫から作品を探す", label: "書物一覧の検索欄の薄い字", note: "何も入れていないとき" },
  "shelf.search.clear": { text: "検索をクリア", label: "書物一覧の検索欄の × の読み上げの名前", note: "画面には出ない" },
  "shelf.search.found": { text: "{冊数}冊が見つかりました", label: "書物一覧の検索の結果の冊数", note: "検索欄に字を入れているとき", vars: "{冊数}" },
  "shelf.search.idle": { text: "あなたが出会った物語", label: "書物一覧の検索欄の下の一言", note: "検索欄が空のとき" },
  "shelf.sort.label": { text: "並び順", label: "並び順の名前" },
  "shelf.sort.newest": { text: "新しい順", label: "並び順の選択肢（新しい順）" },
  "shelf.sort.oldest": { text: "古い順", label: "並び順の選択肢（古い順）" },
  "shelf.sort.alpha": { text: "あいうえお順", label: "並び順の選択肢（あいうえお順）" },
  "shelf.sort.genre": { text: "ジャンル別", label: "並び順の選択肢（ジャンル別）" },

  // 単語帳の上の帯（単語帳を1つ選んだとき）
  "shelf.vocab.back": { text: "← 単語帳一覧に戻る", label: "単語帳の戻るボタン" },
  "shelf.vocab.backToResult": { text: "← 読了の画面に戻る", label: "単語帳の上の、読了の画面へ戻るボタン", note: "読了の画面の新しい単語の知らせから「単語帳を見る」で来たときだけ出る" },
  "shelf.vocab.horizontal": { text: "横書き", label: "単語帳の書き方の切り替え（縦書きのとき）" },
  "shelf.vocab.vertical": { text: "縦書き", label: "単語帳の書き方の切り替え（横書きのとき）" },
  "shelf.vocab.toShelf": { text: "{名前}の本棚", label: "単語帳からその本棚へ行くボタン", vars: "{名前}（クラスターの名前）" },
  "shelf.vocab.searchPlaceholder": { text: "単語を検索...", label: "単語帳の検索欄の薄い字", note: "何も入れていないとき" },

  // 本が1冊も無いとき
  "shelf.empty.title": { text: "まだ本がありません", label: "本が1冊も無いときの文", note: "書物一覧・本棚のタブ" },
  "shelf.empty.gacha": { text: "ガチャで入手する", label: "本が1冊も無いときのボタン" },

  // 書物一覧
  "shelf.list.noMatch": { text: "該当する作品がありません", label: "書物一覧（検索に当たる本が無いとき）" },
  "shelf.list.empty": { text: "まだ本がありません", label: "書物一覧（本が無いとき）" },

  // 本のカード（書物一覧・本棚）
  "shelf.card.viewAria": { text: "{題}の本を大きく見る", label: "カードの表紙の読み上げの名前", note: "画面には出ない", vars: "{題}" },
  "shelf.card.acquired": { text: "入手日: {日付}", label: "カードに指を乗せたときの入手日", note: "マウスを乗せたときの吹き出し", vars: "{日付}" },
  "shelf.card.unread": { text: "未読", label: "カードの読んだかどうか（未読）" },
  "shelf.card.read": { text: "既読", label: "カードの読んだかどうか（既読）", note: "画面には金の紋章が出て、この文は読み上げに使う" },
  "shelf.card.readSeal": { text: "既読", label: "カードの金の紋章の字（読み終えた本）", note: "2〜4字（月桂樹の輪の真ん中に入る。4字は2字ずつ2行）" },
  "shelf.card.favAdd": { text: "{題}をお気に入りに登録", label: "カードの ☆ の読み上げの名前（お気に入りでないとき）", note: "画面には出ない", vars: "{題}" },
  "shelf.card.favRemove": { text: "{題}をお気に入りから解除", label: "カードの ☆ の読み上げの名前（お気に入りのとき）", note: "画面には出ない", vars: "{題}" },
  "shelf.toast.favRemoved": { text: "お気に入りを解除しました", label: "お気に入りを外したときの知らせ" },
  "shelf.toast.favAdded": { text: "お気に入りに登録しました", label: "お気に入りに入れたときの知らせ" },

  // 本棚
  "shelf.shelf.favorites": { text: "お気に入り", label: "本棚の小さなタブ（お気に入り）" },
  "shelf.shelf.genre": { text: "ジャンル別", label: "本棚の小さなタブ（ジャンル別）" },
  "shelf.shelf.cluster": { text: "クラスター別", label: "本棚の小さなタブ（クラスター別）" },
  "shelf.shelf.favEmpty": { text: "お気に入りがありません", label: "本棚のお気に入り（無いとき）" },
  "shelf.shelf.favEmptyNote": { text: "書物一覧・ジャンル別・クラスター別の ☆ で追加できます", label: "本棚のお気に入りの小さな説明（無いとき）" },
  "shelf.shelf.genreCount": { text: "{冊数}冊 ›", label: "本棚のジャンルの冊数", vars: "{冊数}" },
  "shelf.shelf.clusterCount": { text: "{冊数}冊 ›", label: "本棚のクラスターの冊数", vars: "{冊数}" },
  "shelf.shelf.clusterEmpty": { text: "クラスターが設定された作品がありません", label: "本棚のクラスター別（無いとき）" },

  // 単語帳
  "shelf.vocab.locked": { text: "単語帳はまだ解放されていません", label: "単語帳（まだ1つも無いとき）" },
  "shelf.vocab.lockedNote": { text: "作品を読み終えると、その作品の語彙が単語帳に入ります", label: "単語帳の小さな説明（まだ1つも無いとき）", note: "10/22 から単語は読み終えたときに入る（前は手に入れたとき）" },
  "shelf.vocab.wordCount": { text: "{語数}語 ›", label: "単語帳の一覧の語数", vars: "{語数}" },
  "shelf.vocab.noMatch": { text: "該当する単語がありません", label: "単語帳（検索に当たる語が無いとき）" },

  // 本を大きく出す窓と本の部品（大きく出す本は書庫のほか本を引いた結果でも、小さな表紙はホームと読み終えた画面でも同じ部品を使う）
  "shelf.book.wordCount": { text: "{字数}字", label: "大きく出す本の表紙の字数", note: "書式の後ろに「・」でつなぐ", vars: "{字数}（1,234 のように区切る）" },
  "shelf.book.hint": { text: "触れて傾ける・押したまま横にずらすと背表紙が見える", label: "大きく出す本の下の操作の説明" },
  "shelf.book.close": { text: "閉じる", label: "本を大きく見る窓の閉じるボタン", note: "書庫で表紙を押したとき" },
  "shelf.book.read": { text: "読む", label: "本を大きく見る窓の読むボタン", note: "書庫で表紙を押したとき" },
  "shelf.book.formatFallback": { text: "書物", label: "小さな表紙の書式（書式が分からないとき）", note: "書庫のカード・ホームの続きを読む・読み終えた画面の小さな表紙。本のアイコンの絵が無いときだけ" },
} as const satisfies Record<string, UiTextDef>;
